import { render, staticRenderFns } from "./Intro1.vue?vue&type=template&id=ca47849a&scoped=true&"
import script from "./Intro1.vue?vue&type=script&lang=js&"
export * from "./Intro1.vue?vue&type=script&lang=js&"
import style0 from "./Intro1.vue?vue&type=style&index=0&id=ca47849a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca47849a",
  null
  
)

export default component.exports